import { useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { QuizFullLogo } from '@/components/QuizFullLogo';
import { TextField } from '@/components/ui/TextField';
import { useEffectOnce } from '@/hooks';
import { useCodeInputHandlers } from '@/shared/hooks';
import { useAccountT } from '@/shared/i18n/useAccountT';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';

// enterCode 는 증가 시퀀스라 자릿수가 늘어난다 → 고정 cap 대신 넉넉한 상한(오남용 방지용)만.
// 실제 코드 유효성/종류 판별은 백엔드 resolveCode 가 담당한다.
export const JOIN_CODE_MAX_LENGTH = 32;
export function EnterCodeForm({
  codeValue,
  errorMessage,
  isSubmitting,
  onCodeChange,
  onSubmit
}: {
  codeValue: string;
  errorMessage?: string;
  isSubmitting: boolean;
  onCodeChange: (code: string) => void;
  onSubmit: () => void;
}) {
  const {
    t
  } = useTranslation(['common']);
  const accountT = useAccountT();
  const inputRef = useRef<HTMLInputElement>(null);
  // code-login 과 동일한 입력 위생(공백·특수 제거·대문자, IME 조합 가드).
  const codeInputHandlers = useCodeInputHandlers(onCodeChange, JOIN_CODE_MAX_LENGTH);
  useEffectOnce(() => {
    inputRef.current?.focus();
  });
  return <div className="z-40 mb-[40px] flex w-full max-w-[400px] flex-col items-center justify-center rounded-lg bg-white px-lg pb-xl pt-2xl !shadow-lg" data-sentry-component="EnterCodeForm" data-sentry-source-file="EnterCodeForm.tsx">
      <form className="w-full" onSubmit={e => {
      e.preventDefault();
      onSubmit();
    }}>
        <div className="flex w-full flex-col gap-sm">
          <div className="flex flex-col items-center justify-center gap-xs">
            <QuizFullLogo data-sentry-element="QuizFullLogo" data-sentry-source-file="EnterCodeForm.tsx" />
            <div className="pb-sm text-body-md-medium text-neutral">
              {accountT('account:enterCode.dialog.easyFunQuiz')}
            </div>
          </div>
          <div>
            <TextField placeholder={accountT('account:codeEnterModal.placeholder')} className={cn('w-full px-sm [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none', !errorMessage && 'focus:outline focus:outline-violet-300 focus:outline-2 focus:border-transparent', errorMessage && 'border-[#FFACB6] border focus:border-[#FFACB6]')} ref={inputRef} value={codeValue} disabled={isSubmitting} type="text" inputMode="text" {...codeInputHandlers} data-sentry-element="TextField" data-sentry-source-file="EnterCodeForm.tsx" />
            {errorMessage && <p className="mt-3xs pl-xs text-caption-md-medium text-red-500">
                {errorMessage}
              </p>}
          </div>
          <Button variant="contained" intent="strong" size="lg" disabled={isSubmitting || !codeValue.trim()} data-sentry-element="Button" data-sentry-source-file="EnterCodeForm.tsx">
            {isSubmitting ? accountT('account:classroomJoin.verifyingButton') : t('global.enter.button')}
          </Button>
        </div>
      </form>
    </div>;
}